import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { PUBLIC_URL } from '../../constants/env';
export const GrayScaleImage = ({ trialGraphType }) => {
    const { t } = useTranslation();
    const types = {
        // ToDo: Unify the keys so we don't need such awful mapping - this can simply just go all the way to the tag.
        'trend-in-time': {
            'image': 'trial-graph',
            'alt': 'trialTITGraph',
        },
        'commit-detail': {
            'image': 'commits-trial-graph',
            'alt': 'trialCDGraph',
        },
    };
    if (Object.keys(types).includes(trialGraphType)) {
        const image = types[trialGraphType].image;
        const alt = types[trialGraphType].alt;
        return _jsx("img", { className: 'grayscale-graph', src: `${PUBLIC_URL}images/${image}.jpg`, srcSet: `${PUBLIC_URL}images/${image}.jpg 1x,
						${PUBLIC_URL}images/${image}@2x.jpg 2x`, alt: t(alt), width: '100%' });
    }
    return null;
};
